import { render } from "./LogoutIcon.vue?vue&type=template&id=3312a80c&scoped=true"
import script from "./LogoutIcon.vue?vue&type=script&lang=js"
export * from "./LogoutIcon.vue?vue&type=script&lang=js"

import "./LogoutIcon.vue?vue&type=style&index=0&id=3312a80c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3312a80c"]])

export default __exports__